module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_3.9cf903fb.png";